"use strict";

var _frameworkImportPath = require("@storybook/react");

/* eslint-disable import/no-unresolved */
(0, _frameworkImportPath.configure)([require.context('./.storybook', false, /^\.[\\/](?:load-stories\.js)$/)], module, false);